import { render, staticRenderFns } from "./formFive.vue?vue&type=template&id=00dc1470&scoped=true&"
import script from "./formFive.vue?vue&type=script&lang=js&"
export * from "./formFive.vue?vue&type=script&lang=js&"
import style0 from "./formFive.vue?vue&type=style&index=0&id=00dc1470&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc1470",
  null
  
)

export default component.exports